var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.clubsForDropdown.length)?_c('div',[_c('FormGroup',{attrs:{"title":_vm.label}},[_c('Dropdown',{attrs:{"items":_vm.clubsForDropdown,"value":_vm.clubTitle,"primary":"","fill":""},on:{"change":_vm.selectClub}},[_vm._v(_vm._s(_vm.selected ? _vm.selected.value : _vm.$t('Kies club')))])],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }